import "./App.scss";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home";
import About from "./components/About";
import GetOnBoard from "./components/GetOnBoard";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="onboard" element={<GetOnBoard />} />
        <Route path="page" element={<About />} />
        <Route path="post" element={<About />} />
      </Route>
    </Routes>
  );
}

export default App;
